import {
  useState,
  useRef,
  RefObject,
  useContext,
  Dispatch,
  SetStateAction,
} from "react";
import { motion, AnimatePresence } from "motion/react";
import { useOnClickOutside } from "@/hooks/useOnClickOutside";
import { kommuner } from "@/util/index";
import IconFilter from "./icons/IconFilter";
import Location from "./icons/Location";
import { OpgaveListePageOptions } from "@/interfaces/paging";
import { AuthContext } from "@/context/AuthProvider";
import { FilterToggleButton } from "./FilterToggleButton";
import KommuneMultipleSelectCombobox from "./KommuneMultipleSelectCombobox/KommuneMultipleSelectCombobox";

const filterVariants = {
  open: { height: "auto", opacity: 1 },
  closed: { height: 0, opacity: 0 },
};

export default function FiltersDropDown(props: {
  defaultOpgaveOptions: OpgaveListePageOptions;
  opgaveOptions: OpgaveListePageOptions;
  setOpgaveOptions: Dispatch<SetStateAction<OpgaveListePageOptions>>;
  hide: () => void;
  brugerStatuser?: OpgaveBrugerStatusUI[];
  removeFilters?: any;
  state?: { showFilterOptions: boolean; setShowFilterOptions: Function };
}) {
  const { opgaveOptions, setOpgaveOptions } = props;
  const ref = useRef<HTMLDivElement>(null);
  const authState = useContext(AuthContext);
  const { bruger } = authState;
  const [openFilters, setOpenFilters] = useState(false);
  const { brugerId, kommunenr } = opgaveOptions;
  const aktiveKnr = kommunenr?.split(",").map((s) => parseInt(s));
  const aktiveKommuner = kommuner.filter((k) => aktiveKnr?.includes(k.knr));

  useOnClickOutside(ref, (e) => {
    e.stopPropagation();
    setOpenFilters(false);
  });

  return (
    <div
      ref={ref as RefObject<HTMLDivElement>}
      style={{
        position: "relative",
        minWidth: "fit-content",
        left: "-1px",
      }}
    >
      <button
        className={`c-filter-btn btn btn-outline-primary-subtle btn--icon tooltip-center tooltip-top border-1 d-flex align-items-center border-start-1 ${
          openFilters ? "bg-secondary-subtle" : ""
        }`}
        style={{
          borderRadius: "0 6px 6px 0",
          width: "inherit",
          height: "inherit",
        }}
        onClick={(e) => {
          // preventCloseOnSelect &&
          e.stopPropagation();
          e.preventDefault();
          setOpenFilters(!openFilters);
        }}
        aria-label="Filtrér"
      >
        <IconFilter width={22} />
      </button>
      <AnimatePresence>
        {openFilters && (
          <motion.div
            style={{
              position: "absolute",
              left: 0,
              top: "100%",
              zIndex: 600,
              width: "330px",
              minWidth: "330px",
            }}
            variants={filterVariants}
            initial="closed"
            animate="open"
            exit={filterVariants.closed}
            transition={{ damping: 300 }}
            className="c-filter-options bg-white border shadow rounded"
            // key="filter-dropdown"
            key={Math.floor(Math.random())}
          >
            <div className="border-bottom px-3 py-3">
              <h5 className="text-muted fw-normal">Filtre</h5>
            </div>
            <FilterToggleButton
              isActive={brugerId ? true : false}
              setIsActive={(isActive) => {
                setOpgaveOptions({
                  ...opgaveOptions,
                  page: 1,
                  brugerId: isActive && bruger ? bruger.id : undefined,
                });
              }}
            />

            {bruger?.erSkatteforvaltningen && (
              <div className="px-3 py-3">
                <h5 className="fw-normal fs-4 d-flex align-items-center gap-2 mb-3">
                  <span className="d-flex align-items-center text-primary">
                    <Location width={21} />
                  </span>{" "}
                  Kommuner
                </h5>

                <KommuneMultipleSelectCombobox
                  selectedItems={aktiveKommuner}
                  setSelectedItems={(selectedItems) => {
                    const selectedKnrs = selectedItems.map((k) => k.knr);
                    setOpgaveOptions({
                      ...opgaveOptions,
                      page: 1,
                      kommunenr: selectedKnrs.join(","),
                    });
                  }}
                />
              </div>
            )}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
